import { displayName } from "react-gravatar";
import { isSuperAdminRole } from "../MainPage/UserInfo";
import { languageService } from "../../Language/language.service";

export const siteOptionsTexts = [
  { displayName: "Staff", path: "staff" },
  { displayName: "Team", path: "team" },
  { displayName: "Location", path: "locationSetup", checkPermission: true, permissionResource: "LOCATION", permissionAction: "view" },
  { displayName: "Locations Prefix", path: "locationPrefix" },
  // { displayName: "Runs", path: "run" },
  {
    displayName: "Inspection Run Planning",
    path: "inspectionplan",
  },
  { displayName: languageService("Tour Plan"), path: "tour", checkPermission: true, permissionResource: "Tour", permissionAction: "view" },
  { displayName: "AssetTypes Tests", path: "assetTypetestForms" },
  { displayName: "Lists", path: "applicationLists" },
  { displayName: languageService("Leftover Assets"), path: "leftoverAssets" },
  {
    displayName: languageService("Materials"),
    path: "materialList",
    checkPermission: superAdminPermCheck,
    permissionResource: "MATERIAL TYPE LIST",
    permissionAction: "view",
  },
  { displayName: "Location Assignments", path: "locationassignments" },
  { displayName: "Alerts", path: "alerts" },
  { displayName: "Settings", path: "setting" },
  { displayName: "Support", path: "company" },

  //{ displayName: "Line", path: "line" },
  // { displayName: "Asset Type", path: "assetTypes" },
  // { displayName: "General Files", path: "generalInfo" },
];

const superAdminPermCheck = isSuperAdminRole() ? false : true;

export const timpsOptionsTexts = [
  { displayName: "Staff", path: "staff" },
  { displayName: "Team", path: "team" },
  { displayName: "Location", path: "locationSetup", checkPermission: true, permissionResource: "LOCATION", permissionAction: "view" },
  { displayName: "Locations Prefix", path: "locationPrefix" },
  { displayName: "Inspection Run Planning", path: "inspectionplan" },
  { displayName: "Tour Plan", path: "tour", checkPermission: true, permissionResource: "Tour", permissionAction: "view" },
  { displayName: "AssetTypes Tests", path: "assetTypetestForms" },
  { displayName: "Lists", path: "applicationLists" },
  { displayName: "Location Assignments", path: "locationassignments" },
  {
    displayName: languageService("Material Types"),
    path: "materialList",
    checkPermission: superAdminPermCheck,
    permissionResource: "MATERIAL TYPE LIST",
    permissionAction: "view",
  },
  { displayName: languageService("Leftover Assets"), path: "leftoverAssets" },
  { displayName: "Alerts", path: "alerts" },
  { displayName: "Settings", path: "setting" },
  { displayName: "Support", path: "company" },

  // { displayName: "General Files", path: "generalInfo" },
];

export const liteOptionsTexts = [
  { displayName: "Staff", path: "staff" },
  { displayName: "Team", path: "team" },
  { displayName: "Location", path: "locationSetup", checkPermission: true, permissionResource: "LOCATION", permissionAction: "view" },
  { displayName: "Inspection Run Planning", path: "inspectionplan" },
  { displayName: "AssetTypes Tests", path: "assetTypetestForms" },
  { displayName: "Lists", path: "applicationLists" },
  { displayName: "Location Assignments", path: "locationassignments" },
  { displayName: "Support", path: "company" },
];



// WEBPACK FOOTER //
// ./src/components/SetupPage/options.js